import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'
import { BooleanFilterCell, multiSelectFilterCell } from 'components/Filter/FilterCell'
import { CurrenciesFilterCell } from 'components/Filter/FilterCell/CurrenciesFilterCell'
import { WalletTypeFilterCell } from 'components/Filter/WalletFilterCell'
import { useAppSelector } from 'store'

const CountryFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const countries = useAppSelector((state) => state.identity.countries)

  return multiSelectFilterCell({
    items: countries.map((x) => ({ id: x.id, value: x.id, label: x.name })),
  })(props)
}

const TickmillCompanyFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.id, label: x.name })),
  })(props)
}

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const interestRatesWalletConfigurationColumns: GridColumn[] = [
  {
    title: 'Tickmill Company',
    field: 'tickmillCompany.name',
    filterCell: TickmillCompanyFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.tickmillCompany.name) {
        return <td />
      }

      return <td>{props.dataItem.tickmillCompany.name}</td>
    },
    width: 250,
    filterable: true,
    show: true,
  },
  {
    title: 'Country',
    field: 'country.name',
    filterCell: CountryFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.country.name) {
        return <td />
      }

      return <td>{props.dataItem.country.name}</td>
    },
    filterable: true,
    show: true,
  },
  {
    title: 'Currency',
    field: 'currency.name',
    filterCell: CurrenciesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.currency?.id) {
        return <td />
      }
      return <td>{props.dataItem.currency.id}</td>
    },
    filterable: true,
    show: true,
  },
  {
    title: 'Wallet Type',
    field: 'walletType.name',
    filterCell: WalletTypeFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.walletType.name) {
        return <td />
      }

      return <td>{props.dataItem.walletType.name}</td>
    },
    filterable: true,
    show: true,
  },
  {
    title: 'Enabled',
    field: 'enabled',
    filterCell: BooleanFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem?.enabled} disabled />
        </td>
      )
    },
    filterable: true,
    show: true,
  },
]

export default interestRatesWalletConfigurationColumns
